import { AxiosInstance } from 'axios';
import DNSRepositoryInterface, {
  CreateDNSZonesInterface,
  DNSRecordsInterface,
  DNSZonesInterface,
} from '@/services/DNS/Interfaces';
import { DNSRecord } from '@fenix/dns-entities';

export default class DNSRepository implements DNSRepositoryInterface {
  constructor(
    private axios: AxiosInstance,
  ) {
  }

  public async getAllZones(search?: string, page?: number, itemsPerPage?: number): Promise<[DNSZonesInterface[], number]> {
    const res = await this.axios.get('/dns/zones', {
      params: {
        search,
        page,
        itemsPerPage
      },
    });

    return res.data;
  }

  // public async getClientZones(clientId: number): Promise<DNSZonesInterface[]> {
  //   const res = await this.axios.get(`/dns/zones/client/${clientId}`)
  //
  //   return res.data
  // }

  public async getZones(domain: string): Promise<DNSZonesInterface> {
    const res = await this.axios.get(`/dns/zones/${domain}`);

    return res.data;
  }

  public async createDNSZone(newDnsZone: CreateDNSZonesInterface): Promise<void> {
    await this.axios.post('/dns/zones', newDnsZone);
  }

  public async deleteDNSZone(zoneId: number): Promise<boolean> {
    try {
      await this.axios.delete('/dns/zones', {
        data: {
          zoneId,
        },
      });
      return true;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }

  public async updateDNSZoneVisibility(zoneId: number, adminOnly: boolean): Promise<void> {
    await this.axios.patch(`/dns/zones/${zoneId}`, { adminOnly });
  }


  public async getDNSZoneRecords(zoneId: number): Promise<DNSRecordsInterface[]> {
    const res = await this.axios.get(`/dns/zones/${zoneId}/records`);

    return res.data;
  }

  public async createDNSRecord(id: number, record: DNSRecord): Promise<boolean> {
    const res = await this.axios.patch(`/dns/zones/${id}/records`, {
      create: [record],
      delete: [],
    });

    return res.status === 202;
  }

  public async deleteDNSRecord(id: number, recordId: number): Promise<boolean> {
    const res = await this.axios.patch(`/dns/zones/${id}/records`, {
      create: [],
      delete: [recordId],
    });

    return res.status === 204;
  }

  public async searchZones(search: string): Promise<DNSZonesInterface[]> {
    const res = await this.axios.post(`/dns/zones/search`, {
      search,
    });

    return res.data;
  }

  public async getDepartments(): Promise<string[]> {
    const res = await this.axios.get('/dns/departments');

    const departments = res.data;

    const result = [];
    for (const department of departments) {
      result.push(department.departmentId);
    }

    return result;
  }

  public async demoteDepartment(departmentId: string): Promise<void> {
    await this.axios.delete(`/dns/departments/${departmentId}`);
  }

  public async promoteDepartment(departmentId: string): Promise<void> {
    await this.axios.post('/dns/departments', { id: departmentId });
  }

  public async syncDNS(domain?: string, server?: string, step?: number): Promise<void> {
    await this.axios.patch('/dns/zones/worker/sync', { domain, server, step });
  }

  public async activateDNSZone(zoneId: number): Promise<void> {
    await this.axios.patch(`/dns/zones/${zoneId}/activate`);
  }
}
